import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import { useSelector } from "react-redux";

import { FaClock, FaLocationDot, FaUser, FaUsers } from "react-icons/fa6";

import { FaCalendarAlt, FaGolfBall } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function ShowEeventsCalendar2() {
  const navigate = useNavigate();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const location = useLocation();
  const { eventId, pack, membershipId, isGolfer, memberId } = location.state;
  console.log("location.state", location.state);

  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  // State variables from React Native version
  const [event, setEvent] = useState(null);
  const [eventMessage, setEventMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [attending, setAttending] = useState(false);
  const [eventAttendance, setEventAttendance] = useState(null);
  const [oneTypeAllowedPacks, setOneTypeAllowedPacks] = useState([]);
  const [manyTypes, setManyTypes] = useState([]);
  const [typeLimit, setTypeLimit] = useState(null);
  const [packYearlyLimit, setPackYearlyLimit] = useState(0);
  const [memberTotalAttendanceCount, setMemberTotalAttendanceCount] =
    useState(0);
  const [memberTypeCount, setMemberTypeCount] = useState(0);
  const [golfersCount, setGolfersCount] = useState(0);
  const [nonGolfersCount, setNonGolfersCount] = useState(0);
  const [eventHappened, setEventHappened] = useState(false);
  const [filterActivated, setFilterActivated] = useState(false);
  const [user, setUser] = useState(null);
  const [canFetch, setCanFetch] = useState(false);
  const [membership, setMembership] = useState(null);
  const [enterBlock2, setEnterBlock2] = useState(false);
  const [disableButton2, setDisableButton2] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  // const { i18n, t } = useTranslation();
  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };
  // Fetch user data
  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setCanFetch(true);
    }
  }, [baseUrl]);

  const fetchEvent = async () => {
    try {
      setEvent(null);
      setIsLoading(true);

      const response = await axios.get(`${baseUrl}/golf_events/${eventId}`);

      setEvent(response.data?.event);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setCanFetch(false);
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    if (canFetch) {
      fetchEvent();
    }
  }, [canFetch, membership, fetchEvent]);

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.background}`;
    }

    return "https://sysgtm.gtm.ma//images/packs/visitor-menu.png";
  };
  const imagess2 = getimagess(membership?.membership_packs?.background);

  if (isLoading) {
    return (
      <div className="flex flex-col">
        <div className="mx-0 sm:mx-[1rem]  lg:mx-[3rem] p-4 sm:p-6 mb-[5rem] border  bg-white shadow-custom bg-opacity-[87%]  min-h-screen rounded-3xl">
          <div className="bg-white min-h-screen bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] py-8 md:py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
          </div>
        </div> 
      </div>
    );
  }

  if (!event) {
    return (
      <div className="flex flex-col">
        <div className="mx-0 sm:mx-[1rem]  lg:mx-[3rem] p-4 sm:p-6 mb-[5rem] border  bg-white shadow-custom bg-opacity-[87%]  min-h-screen rounded-3xl">
          <div className="bg-white min-h-screen bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] py-8 md:py-12">
            <p>{t("messages.event.not_found")}</p>
          </div>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return new Date(dateString).toLocaleDateString("fr-FR", options);
  };

  function capitalize(str) {
    return str && typeof str === "string"
      ? str.charAt(0).toUpperCase() + str.slice(1)
      : str;
  }

  return (
    <div>
      <div className="flex flex-col">
        <div
          className="mx-0 sm:mx-[1rem]  lg:mx-[3rem] p-4 sm:p-6 mb-[5rem] border  bg-white shadow-custom bg-opacity-[87%]  min-h-screen rounded-3xl"
        >
          <div className="flex flex-col gap-6 md:gap-12 rounded-lg w-full">
            <div>
              <strong className="text-lg md:text-xl">
                <strong className="text-lg md:text-xl">
                  {event?.date
                    ? new Date(event.date).toLocaleDateString(
                        language === "fr" ? "fr-FR" : "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )
                    : ""}
                </strong>
              </strong>
            </div>
            <div className="flex flex-col justify-center gap-6 md:gap-12 items-center w-full">
              {/* <div className="w-full flex justify-center">
              <img
                src={event.photo}
                className="w-full lg:max-w-[350px] max-w-[200px]"
                alt="Event"
              />
            </div> */}

              <div className="flex flex-col justify-center items-center gap-4 md:gap-8 px-4 md:px-16 w-full">
                <div className="font-bold text-center mt-2 md:mt-4 text-xl md:text-3xl">
                  {event.name}
                </div>
                <div className="leading-relaxed md:leading-loose flex flex-col gap-2 md:gap-4 text-sm md:text-base">
                  {event.description
                    ? event.description
                        .split("\n")
                        ?.map((paragraph, index) => (
                          <span key={index}>{paragraph}</span>
                        ))
                    : language == "fr"
                    ? "Aucune description disponible"
                    : "No description available"}
                </div>
                <div className="flex flex-col justify-start gap-2 md:gap-3 w-full">
                  <strong className="text-base md:text-lg">
                    {t("messages.details.title")}
                  </strong>
                  <div className="flex gap-1">
                    <div className="flex flex-col gap-2 md:gap-3 justify-start items-start text-sm md:text-base">
                      <span className="flex items-center gap-1">
                        <FaCalendarAlt
                          color="red"
                          className="text-gray-500 text-sm md:text-base"
                        />
                        <strong>{t("messages.details.date")}</strong>:{" "}
                        {event?.date
                          ? new Date(event.date).toLocaleDateString(
                              language === "fr" ? "fr-FR" : "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )
                          : ""}
                      </span>
                      <span className="flex items-center gap-1">
                        <FaClock
                          color="red"
                          className="text-gray-500 text-sm md:text-base"
                        />
                        <strong>{t("messages.details.time")}</strong>:{" "}
                        {event.time || t("messages.details.to_be_announced")}
                      </span>
                      <span className="flex items-center gap-1">
                        <FaLocationDot
                          color="red"
                          className="text-sm md:text-base"
                        />
                        <strong>{t("messages.details.venue")}</strong>:{" "}
                        {event.venue
                          ? event.venue
                          : language == "fr"
                          ? "Détails du lieu non disponibles"
                          : "Venue details not available"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
